import { createRouter, createWebHistory } from 'vue-router'
import store from '@/configure/store'

let moduleRoutes = []

const routes = [
  {
    path: '/',
    name: '/index',
    redirect:'/workbench',
  },
  {
    path:'/workbench',
    name:'workbench',
    component: () => import('@/pages/commonModule/indexAdminWorkbench/index')
  },
  {
    path: '/indexAdminLogin',
    component: () => import('@/pages/commonModule/indexAdminLogin/index')
  },
  {
    path: '/:pathMatch(.*)',
    name: '/index404',
    component: () => import('@/pages/commonModule/index404/index')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  document.title = store.state.systemMetaBaseData.systemName
  // if (store.state.systemMetaBaseData.systemLogo != null) {
  //   let $favicon = document.querySelector('link[rel="icon"]');
  //   if ($favicon !== null) {
  //     $favicon.href = store.state.systemMetaBaseData.systemLogo.systemFileUrl;
  //   } else {
  //     $favicon = document.createElement("link");
  //     $favicon.rel = "icon";
  //     $favicon.href = store.state.systemMetaBaseData.systemLogo.systemFileUrl;
  //     document.head.appendChild($favicon);
  //   }
  // }
  if (to.path !== '/indexAdminLogin') {
    const adminToken = store.state.userData.adminToken
    if (adminToken === '' || adminToken === undefined) {
      next('/indexAdminLogin')
    } else {
      next()
    }
  } else {
    next()
  }
})

router.beforeEach((to, from, next) => {
  document.title = store.state.systemMetaBaseData.systemName
  next()
})

export default router
